import TEXT, { EL, HTMLELEMENT } from '../../DOM/text/TEXT.js';
/** A Paragraph Element */
export default class P extends TEXT {
    constructor(node, model) {
        super(node, HTMLELEMENT.P, model);
    }
}
export { EL };
